import { DealerData, DealerResponse, ResponseSelector } from "../../types";

export const getDealers = (distance?: number): ResponseSelector<DealerResponse, DealerData[]> => {
  if (distance) {
    const getDealerShortList: ResponseSelector<DealerResponse, DealerData[]> = res => res.data.filter(dealer => dealer.distance < distance);
    return getDealerShortList;
  }

  const getDealersFullList: ResponseSelector<DealerResponse, DealerData[]> = (res) => res.data;
  return getDealersFullList;
};

export const getDealer = (id?: string): ResponseSelector<DealerResponse, DealerData> => {
  const getSingleDealer: ResponseSelector<DealerResponse, DealerData> = (res) => res.data.filter(dealer => dealer.static_dealer_id === id)[0];
  return getSingleDealer;
};

export const getLocalDealer = (): ResponseSelector<DealerResponse, DealerData> => {
  const getDealer: ResponseSelector<DealerResponse, DealerData> = (res) => res.data[0];
  return getDealer;
};

